import axios from 'axios';

const state = {
  noViewed: null,
  collectCount: null,
  notSeeCount: null,
  allowInterviewCount: null,
  failInterviewCount: null
};

const mutations = {
  SET_NUM(state, num) {
    state.noViewed = num;
  },
  SET_RECORD(state, obj) {
    state.collectCount = obj.collectCount;
    state.notSeeCount = obj.notSeeCount;
    state.allowInterviewCount = obj.allowInterviewCount;
    state.failInterviewCount = obj.failInterviewCount;
  }
};

const actions = {
  setNum({ commit }) {
    axios.get('/userApi/company/countData', { headers: { Authorization: 'Bearer ' + JSON.parse(window.sessionStorage.user).token } }).then(res => {
      commit('SET_NUM', res.data);
    });
  },
  setRecordNum({ commit }) {
    axios.get('/userApi/company/countNum', { headers: { Authorization: 'Bearer ' + JSON.parse(window.sessionStorage.user).token } }).then(res => {
      commit('SET_RECORD', res.data);
    });
  }
};

export default {
  state,
  mutations,
  actions
};
